import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Exported so `index.test.ts` can call it directly: `beforeLoad`'s generic
 * context type is needlessly heavy to fabricate in a test for a redirect
 * that doesn't read it.
 *
 * Marketing links land bare on `/`, often carrying UTM/click-ID params for
 * the advertised CTA — keep them on the redirect chain rather than dropping
 * them here before any capture code runs (PX-274).
 */
export function redirectToParticipants(): never {
  throw redirect({ to: '/participants', search: true });
}

export const Route = createFileRoute('/')({
  beforeLoad: redirectToParticipants,
});
